import * as React from 'react';
import styled from 'styled-components';
import { space, themeGet } from 'styled-system';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { Overlay } from '../ImageOverlay';
import Loader from '../loaders/Loader';
import { Box } from '..';
import Button from '../Button';
import { Plus, Grid, Check } from 'react-feather';
import { theme } from '../../theme';
import { H3 } from '../../typography';

type ContainerProps = {
  src?: string | null;
};

type Props = {
  heading?: string;
  buttonText?: string;
  loading?: boolean;
  onButtonPress?: () => void;
  onClickRemove?: (d?: string | number | null) => void;
  onOrderPress?: () => void;
  icon?: React.ReactNode;
  images?: boolean | null;
  onClickConfirm?: () => void;
};

export const AllImagesWrapper = styled.div<StyledSystemProps>`
  ${space};
  display: flex;
  flex: 1;
  overflow: hidden;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
`;

export const Container = styled.div`
  background-image: url(${({ src }: ContainerProps) => src});
  background-size: cover;
  height: 250px;
  display: block;
  width: 100%;
  position: relative;
  border-radius: 4px;
`;

export const ImageWrapper = styled.div<StyledSystemProps>`
  ${space};
  display: flex;
  overflow: hidden;
  flex-flow: row;
  position: relative;
  border-radius: 4px;
  box-sizing: border-box;
  height: 250px;
  width: 25%;
  border: 1px solid ${themeGet('colors.paleGrey', '#EEE')};
  &:hover ${Overlay} {
    top: 0;
    opacity: 1;
    pointer-events: all;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const ActionsWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Header = ({
  heading,
  loading,
  onOrderPress,
  onButtonPress,
  buttonText,
  icon,
  images,
  onClickConfirm,
}: Props) => {
  return (
    <Box pb={4} width="100%" flexDirection="row" alignItems="center" justifyContent="space-between">
      <H3 fontWeight={300}>{heading}</H3>
      <ActionsWrap>
        {loading && <Loader color={theme.colors.putty} />}
        {onClickConfirm && (
          <Button
            bg="success"
            type="button"
            ml={4}
            color="white"
            width="auto"
            maxWidth="220px"
            text="Confirm"
            onClick={onClickConfirm}
            isLoading={loading}
            icon={!loading && <Check size={20} color="white" />}
          />
        )}
        {images && onOrderPress && (
          <Button
            bg="coal"
            type="button"
            ml={4}
            color="white"
            width="auto"
            maxWidth="220px"
            text="Reorder"
            onClick={onOrderPress}
            icon={<Grid size={20} color="white" />}
          />
        )}
        {onButtonPress && (
          <Button
            bg="coal"
            type="button"
            ml={4}
            color="white"
            width="auto"
            maxWidth="220px"
            text={buttonText}
            onClick={onButtonPress}
            icon={icon || <Plus size={20} color="white" />}
          />
        )}
      </ActionsWrap>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/gallery/Elements.tsx